app.controller('UIController', function($scope, legalBarService, $rootScope, loginService, $translate) {
    $scope.homepageProgramSlickSettings = {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    };

    $scope.UI = {
        sidebarOpened: false,
        disableBodyScroll: false,
        legalBar: legalBarService
    };

    $scope.showModal = function(selector) {
        var modal = angular.element(selector);
        var iframe = modal.find("iframe");
        if (iframe.data("src")) {
            iframe.attr("src", iframe.data("src"));
        }

        modal.modal();

        modal.on("hide.bs.modal", function() {
            var iframe = this.querySelector("iframe");
            iframe.setAttribute("data-src", iframe.src);
            iframe.src = "";
        });
    };

    this.$onInit = () => {
        $rootScope.lang = $("html").attr("lang");
        if ($rootScope.lang) {
            $translate.use($rootScope.lang);
        }
    };
});
